<template>
  <CollapseSection
    title="Relação de capacidade no mercado"
    :expanded="expanded"
    :disabled="disabled"
    :loading="loading"
    section-id="capacidade_mercado"
    @toggleSection="$emit('toggleSection')"
  >
    <div class="pb-5">

			<market-capacity ref="marketCapacity" v-if="economicGroupID"
				:loadOnCreated="false" :economicGroup="dataFormCompany" />

    </div>
  </CollapseSection>
</template>

<script>
import { CollapseSection } from "@/components";
import { MarketCapacity } from "@/components/Client";

export default {
  components: { CollapseSection, MarketCapacity },
  props: {
    expanded: Boolean,
    disabled: Boolean,
    economicGroupID: String,
  },
  data: () => ({
    loading: false,
		dataFormCompany: {}
  }),
	created() {
			this.resetAlert();

			if (this.expanded && this.economicGroupID) {
				this.findData();
			}
	},
  methods: {
    findData() {
      this.dataFormCompany.id = this.economicGroupID;
			this.$nextTick(() => {
				if (this.$refs.marketCapacity) {
					this.$refs.marketCapacity.getInsurerLimit()
				}
			})
    },
  },
  watch: {
    expanded: function (value) {
      if (value) {
        this.findData();
      }
    },
  },
};
</script>
<style></style>
